export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";